import React from 'react';
import styles from '../styles/login.module.scss';
import 'antd/dist/antd.css';
import {Alert, Icon, message, Spin} from 'antd';
import CommonUtils from "../tools/CommonUtils";
import StorageUtils from "../tools/StorageUtils";
import WebServerRestClient from "../tools/WebServerRestClient";

export default class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            showMessageDialog: false
        }
    }

    componentDidMount() {
        const clientHeight = document.body.clientHeight;
        let top = (clientHeight - 654) / 2;
        document.getElementById('loginCenter').style.paddingTop = top + 'px';
    }

    handleInputFocus(event) {
        const target = event.target;
        if (target.type === 'text' || target.type === 'password') {
            this.setState({showMessageDialog: false});
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    login() {
        this.setState({showMessageDialog: false});
        let username = this.state.username;
        let password = this.state.password;
        if (username == '') {
            this.setState({showMessageDialog: true, message: "Please enter the username"});
            return false;
        }
        if (password == '') {
            this.setState({showMessageDialog: true, message: "please enter the password"});
            return false;
        }
        this.setState({doing: true});
        new WebServerRestClient().POST('/open/sys-admin-login', {
            username: this.state.username,
            password: this.state.password
        }).then(response => {
            console.log("login response -> " + JSON.stringify(response));
            this.setState({doing: false});
            if (response.code == 200) {
                let userInfo = {
                    userId: response.data.userId,
                    username: response.data.username,
                    token: response['msg']
                };
                StorageUtils.saveUser(userInfo);
                window.CurrentUser = userInfo;
                this.props.history.push('/');
            } else {
                this.setState({showMessageDialog: true, message: response['msg']});
            }
        }).catch(err => {
            this.setState({doing: false});
            message.error("Error: " + err.message);
        });
    }

    render() {
        return (
            <div className={styles.container}>
            <div id="loginCenter" className={styles.login_container}>
                <div className={styles.login_center}>
                    <div className={styles.login_form}>
                        <h1>Web Management</h1>
                        <input type={'text'} name={'username'} className={styles.form_input}
                               placeholder={'Username'}
                               onFocus={this.handleInputFocus.bind(this)}
                               onChange={this.handleInputChange.bind(this)}/>
                        <input type={'password'} name={'password'} className={styles.form_input}
                               placeholder={'Password'}
                               onFocus={this.handleInputFocus.bind(this)}
                               onChange={this.handleInputChange.bind(this)}/>
                        {this.state.showMessageDialog ?
                            <div className={styles.message_box}>
                                <Alert message={this.state.message} type="error" closable={true}
                                       onClose={()=>{this.setState({showMessageDialog: false})}}/>
                            </div>
                            :
                            null
                        }
                        <div className={styles.form_checkbox_row}>
                            <input type={'checkbox'} name={'remember'} checked={true}
                                   className={styles.form_input_checkbox}
                                   onChange={this.handleInputChange.bind(this)}/>
                            <label className={styles.form_label_checkbox}>Remember me</label>
                        </div>
                        <div className={styles.form_button_row}>
                            <button className={styles.form_button} onClick={this.login.bind(this)}>
                                {this.state.doing ?
                                    <Spin indicator={<Icon type="loading" className='icon_loading' spin/>}/>
                                    :
                                    'Log In'
                                }
                            </button>
                        </div>
                    </div>
                </div>
                <div className={styles.login_image}></div>
            </div>
            </div>
        );
    }

}
